import { BASE_URL } from 'config/urls';

import { post, requestSdk } from 'utils/sdk';

export const initializeMeetingBoard = (data) =>
  requestSdk(() => post(`${BASE_URL}/v1/meetings/boards/initialize/`, data));
